import { ParallaxBg, FadeUp } from "@/components/Parallax";
import { IMG } from "@/lib/images";

const IMAGES = [
  { src: IMG.heroExterior, label: "Trailer on location · Zion backdrop" },
  { src: IMG.interiorWide, label: "Interior · Overview" },
  { src: IMG.interiorSink, label: "Interior · Sink detail" },
  { src: IMG.wedding, label: "Weddings" },
  { src: IMG.champagne, label: "Private & corporate events" },
  { src: IMG.festival, label: "Concerts & festivals" },
  { src: IMG.zion, label: "Southern Utah landscape" },
];

export default function Gallery() {
  return (
    <div>
      <ParallaxBg image={IMG.heroExterior} minHeight="min-h-[55vh]" overlay="bg-gradient-to-b from-black/40 to-black/70" speed={0.22}>
        <div className="mx-auto max-w-6xl h-full px-6 md:px-10 lg:px-16 flex items-end pb-14 min-h-[55vh]">
          <FadeUp className="text-ivory">
            <div className="overline text-ivory/70">Gallery</div>
            <h1 className="h-display mt-3 text-5xl md:text-7xl leading-[1.02]">Moments made comfortable.</h1>
            <p className="mt-6 text-ivory/85 max-w-2xl text-lg">Interiors, exteriors, and events across Southern Utah.</p>
          </FadeUp>
        </div>
      </ParallaxBg>

      <section className="section">
        <div className="mx-auto max-w-7xl columns-1 md:columns-2 lg:columns-3 gap-5 space-y-5">
          {IMAGES.map((img, i) => (
            <FadeUp key={img.src} delay={(i % 3) * 0.05}>
              <figure className="break-inside-avoid rounded-3xl overflow-hidden border border-stone bg-white group">
                <div className="overflow-hidden">
                  <img src={img.src} alt={img.label} className="w-full h-auto transition-transform duration-700 group-hover:scale-[1.04]" />
                </div>
                <figcaption className="px-5 py-3 overline">{img.label}</figcaption>
              </figure>
            </FadeUp>
          ))}
        </div>
      </section>
    </div>
  );
}
